/* @flow */
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import DialogContent from 'components/DialogContent.jsx';

import './styles/JoinPageLoadingIndicator.scss';

const JoinPageLoadingIndicator = React.createClass({
  render() {
    return (
      <DialogContent
        className="JoinPageLoadingIndicator"
        onRequestHide={() => {}}>
        <BoxBody divided={false}>
          <LoadingIndicator />
        </BoxBody>
      </DialogContent>
    );
  },
});

export default JoinPageLoadingIndicator;



// WEBPACK FOOTER //
// ./src/join/components/JoinPageLoadingIndicator.jsx